var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center mb-4"},[_c('memlist-checkbox',{attrs:{"text":_vm.local_requirement.name},model:{value:(_vm.local_requirement.checked),callback:function ($$v) {_vm.$set(_vm.local_requirement, "checked", $$v)},expression:"local_requirement.checked"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }